import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");
    if (!code || !state) {
      if (params.get("error")) toast.error("Google sign-in was cancelled");
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const redirect_uri = window.location.origin + "/auth/google";
        const { data } = await api.post("/auth/google/callback", { code, state, redirect_uri });
        if (data?.session_token) localStorage.setItem("vm_session_token", data.session_token);
        setUser(data.user);
        navigate("/profile", { replace: true });
      } catch (e) {
        toast.error(e?.response?.data?.detail || "Google sign-in failed");
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center" data-testid="auth-callback">
      <div className="flex flex-col items-center gap-3 text-neutral-400">
        <Loader2 className="h-6 w-6 animate-spin text-volt-400" />
        <p className="text-sm">Completing sign-in…</p>
      </div>
    </div>
  );
}
